import { CURRENCY_MINOR_UNITS as D } from '../constants/CurrencyMinorUnits.js';

function n(n,t,o){if(o){var i=D[t]||0;return n/Math.pow(10,i)}return n}

export { n as toPrice };
//# sourceMappingURL=toPrice.js.map
